import React, { useState, ChangeEvent } from 'react';
import SweetAlert from '../Shared/Notification/index';
import { ConstantActions } from '../../Services/_actions/constant.actions';
import FileInput from '../Shared/FileUploadPreview/FileInput.jsx';
import { Card, Col, Container, Row } from 'react-bootstrap';
import { useSnackBar } from '../FlowBuilder/Common/SnackBar/index.tsx';
import DynamicBreadcrumbs from '../Shared/Breadcrumb/index.tsx';
import HomeIcon from '@mui/icons-material/Home';
import { IconButton } from '@mui/material';
import { useNavigate } from 'react-router';
import { BLOCKED_EXTENSIONS, WHATSAPP_ALLOWED_MIME, WHATSAPP_LIMITS } from '../Whatsapp/Template/template.constant.js';

const UrlGenerator: React.FC = () => {
  const { showSnackBar } = useSnackBar();
  const constantActions = ConstantActions();
  const [file, setFile] = useState<File | null>(null);
  const [url, setUrl] = useState<string>('');
  const navigate = useNavigate();

  const breadcrumbsData = [
    {
      label: (
        <IconButton color="primary">
          <HomeIcon />
        </IconButton>
      ),
      onClick: () => navigate('/'),
    },
    { label: 'Tools', onClick: () => navigate('/r/tools') },
    { label: 'Url Genrator' },
  ];

  // Define maximum file sizes in bytes
  const MAX_IMAGE_SIZE = 2 * 1024 * 1024; // 2 MB
  const MAX_VIDEO_SIZE = 20 * 1024 * 1024; // 20 MB
  const MAX_DOCUMENT_SIZE = 5 * 1024 * 1024; // 5 MB

   const inferDocType = (mime: string): 'image' | 'video' | 'audio' | 'file' | null => {
      if (WHATSAPP_ALLOWED_MIME.image.includes(mime)) return 'image';
      if (WHATSAPP_ALLOWED_MIME.video.includes(mime)) return 'video';
      if (WHATSAPP_ALLOWED_MIME.audio.includes(mime)) return 'audio';
      if (WHATSAPP_ALLOWED_MIME.file.includes(mime)) return 'file';
      return null;
    };
    const bytesToMB = (bytes: number) => (bytes / (1024 * 1024)).toFixed(2);
  

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const selectedFile = event.target.files?.[0];

    if (!selectedFile) return;
        const fileName = selectedFile?.name?.toLowerCase();
        const ext = fileName.split('.').pop();
        if (BLOCKED_EXTENSIONS.has(ext)) {
          showSnackBar(`"${ext}" files are not allowed for security reasons.`, 'error');
          event.target.value = '';
          return;
        }
        const typeGroup = inferDocType(selectedFile.type);
        if (!typeGroup) {
          showSnackBar(`Unsupported file type (${selectedFile.type || ext}).`, 'error');
          event.target.value = '';
          return;
        }
    
        const limit = WHATSAPP_LIMITS[typeGroup];
        if (selectedFile.size > limit) {
          showSnackBar(
            `File too large for ${typeGroup}. Max ${bytesToMB(limit)} MB. Your file is ${bytesToMB(selectedFile?.size)} MB.`,
            'error'
          );
          event.target.value = '';
          return;
        }

    // Validate file size
    if (selectedFile.size > MAX_IMAGE_SIZE && selectedFile.type.startsWith('image')) {
      showSnackBar('Image files must be smaller than 2 MB.', 'error');
      return;
    }

    if (selectedFile.size > MAX_VIDEO_SIZE && selectedFile.type.startsWith('video')) {
      showSnackBar('Video files must be smaller than 20 MB.', 'error');
      return;
    }

    if (
      selectedFile.size > MAX_DOCUMENT_SIZE &&
      !selectedFile.type.startsWith('image') &&
      !selectedFile.type.startsWith('video')
    ) {
      showSnackBar('Document files must be smaller than 5 MB.', 'error');
      return;
    }

    // Validate file type
    if (!['image/jpeg', 'image/png', 'video/mp4', 'application/pdf'].includes(selectedFile.type)) {
      showSnackBar('Invalid file type. Accepted types are JPEG, PNG, MP4, and PDF.', 'error');
      return;
    }

    setFile(selectedFile);
  };

  const handleUpload = async () => {
    if (!file) {
      showSnackBar('Please select a file to upload.', 'error');
      return;
    }
    // const myFilename = `${Date.now().toString()}${file.name}`.replace(/ /g, '_');
    // const updatedFile = new File([file], myFilename, { type: file.type });
    const formDataToUpload = new FormData();
    formDataToUpload.append('file', file);
    try {
      const resp = await constantActions.uploadFileS3Bucket(formDataToUpload);
      let link = '';
      console.log(resp, 'Upload Response');

      // if (resp?.$response?.httpResponse?.statusCode) {
      //   link = `${process.env.REACT_APP_IMAGE_URL}/${myFilename}`;
      //   setUrl(link);
      //   showSnackBar('File uploaded successfully!', 'success');
      // }
      if (resp?.status === 200 && resp?.data?.data) {
        link = resp?.data?.data?.url ?? '';
        setUrl(link);
      }
    } catch (error: any) {
      showSnackBar(`Error uploading file: ${error.message}`, 'error');
    }
  };

  return (
    <Container fluid className=" vh-50 style-file-upload">
      <DynamicBreadcrumbs
        items={breadcrumbsData}
        onBreadcrumbClick={(e, item) => item?.onClick?.()}
      />
      <Row className="m-auto" style={{ paddingTop: '60px' }}>
        <Col>
          <Card style={{ width: '20%', height: 'auto', margin: '0 auto', paddingBottom: '8px' }}>
            <Card.Body>
              <Card.Title className="mt-1">Upload a File</Card.Title>
              <div className="pt-3" style={{ justifyItems: 'center' }}>
                <FileInput
                  onFileSelect={handleFileChange}
                  onFileRemove={() => setFile(null)}
                  onFileUpload={handleUpload}
                  file={file}
                  accept="image/jpeg, image/png, video/mp4, application/pdf"
                />
                <p style={{ fontSize: '12px', color: '#6b7280', marginTop: '8px' }}>
                   Allowed: JPEG (≤2MB), PNG (≤2MB), MP4 (≤20MB), PDF (≤5MB)
                </p>
              </div>
              {url && (
                <>
                  <Card.Text>File uploaded successfully!</Card.Text>
                  <Card.Link href="#" onClick={() => navigator.clipboard.writeText(url)}>
                    Copy URL
                  </Card.Link>
                  <Card.Link href={url} target="_blank" rel="noopener noreferrer">
                    Open Uploaded File
                  </Card.Link>
                </>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default UrlGenerator;
